
import { ElectronFunctions  } from "@/utils/electron/electron";
import { getNewElectronDefaultPrinterSettings, IElectronPrinter } from "@/utils/electron/electron-printer";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			defaultPrinterSettings: getNewElectronDefaultPrinterSettings(),
		};
	},
	props: {
		printers: {
			type: Array as ()=>IElectronPrinter[],
			required: true
		},
		layoutId: {
			type: Number,
			required: true
		}
	},
	computed: {
		printerItems():ISelectItem<string>[]{
			let result:ISelectItem<string>[] = [
				{
					text: this.$ct("common.none"),
					value: ""
				}
			];

			result.push(...this.printers.map(p=>{
				return {
					text: p.name,
					value: p.deviceId
				};
			}));

			return result;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			ElectronFunctions.setDefaultPrinterIdForLabelLayout(this.layoutId, this.defaultPrinterSettings);
			this.close();
		}
	},
	mounted(){
		this.defaultPrinterSettings = ElectronFunctions.getDefaultPrinterIdForLabelLayout(this.layoutId);
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
